function getLocationReady() {
  return new Promise(resolve => {
    let script = document.getElementById("getLocationScript");
    if (script) {
      return resolve(getLocation());
    }
    script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://webapi.amap.com/maps?v=1.4.4&key=1365bec49ac05a25c3175fe847b34394";
    script.id = "getLocationScript";
    document.head.appendChild(script);

    script.addEventListener("load", () => {
      resolve(getLocationReady());
    });
  });
}

//定位
function getLocation() {
  return new Promise((resolve, reject) => {
    AMap.plugin("AMap.Geolocation", () => {
      const geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,
        // timeout: 5000,
        noGeoLocation: 0
      });

      geolocation.getCurrentPosition((status, result) => {
        // console.log("获取城市信息", status, result);
        if (status === "complete") {
          resolve({ ...result.addressComponent, ...result });
        } else {
          // console.log("调用使用ip获取定位方法");
          geolocation.getCityInfo((status, result) => {
            // console.log(status, result);
            if (status === "complete") {
              resolve(result);
            } else {
              reject(result);
            }
          });
        }
      });
    });
  });
}

export async function useLocation() {
  return await getLocationReady();
}
